import React, {useEffect, useState} from 'react'
import NavigationLayout from '../../Components/NavigationLayout'
import {Page} from '@shopify/polaris'
import InvitesTable from './InvitesTable'
import axios from "../../Assets/Lib/axios";
import Cookies from "js-cookie";
import {VERIFICATION_TYPES} from "../../global";

const InvitesList = () => {
    const [successVouchers, setSuccessVouchers] = useState([]);

    const getVouchersList = () => {
        const accreditationTypeId = Cookies.get("accreditation_type_id");
        axios.get(`admin/v1/verification-code/${accreditationTypeId}`, {
            params: {
                type_ids: [
                    VERIFICATION_TYPES.APPLICATION_USER_INVITE_SUBMISSION
                ]
            }
        })
            .then((res) => {
                const response = res?.data;
                setSuccessVouchers(response);
            }).catch((err) => {
            console.log("error", err)
        }).finally(() => {
        });
    }

    useEffect(() => {
        getVouchersList();
    }, []);
    return (
        <NavigationLayout>
            <Page fullWidth divider primaryAction={{
                content: <p style={{color: "white"}}>Upload User Invites</p>,
                url: "/admin/user-invites/add",
            }}>
                {/* Voucher Table */}
                {
                    successVouchers.length === 0 ? (
                        <>
                            <p>No successful vouchers found.</p>
                        </>
                    ) : (<InvitesTable vouchers={successVouchers} tabelTitle="Success Vouchers"/>)
                }
            </Page>
        </NavigationLayout>
    )
}

export default InvitesList;